export const GLOBAL_LOAD = 'globalLoad';
export const GLOBAL_INTERACTION = 'globalInteraction';
export const ON_PAGE_LOAD = 'onPageLoad';
export const GLOBAL_ONCLICK = 'globalOnclick';
export const CALL_EMAIL = 'call-email';
export const REFERRAL_EXIT = 'referral-exit';
export const GLOBAL_DOWNLOAD = 'global-download';
export const SITE_SECTION = 'e-switch assist';
export const SITE_LEVEL = 'fpro:e-switch assist';
export const PAGE_NAME = 'fpro:e-switch assist';
export const DETAILED_ASSESSMENT_BUTTON_TOOL = 'event:sign in';
export const REFERRAL_EXIT_ACTION = 'brand referral, tool';

// Tool and tool descriptors
export const GET_QUICK_ESTIMATE_BUTTON_TOOL = 'event:quick estimate';
export const GET_QUICK_ESTIMATE_BUTTON_TOOL_DESCRIPTOR = 'quick estimate:show results';
export const EMAIL_US_BUTTON_TOOL = 'event:lead submitted';
export const EMAIL_US_BUTTON_TOOL_DESCRIPTOR = 'lead submitted:click to email';
export const REFERRAL_EXIT_TOOL = 'event:brand referral';

// CTA to be appended here <CTA>:sign in
export const DETAILED_ASSESSMENT_BUTTON_TOOL_DESCRIPTOR = ':sign in';

// CTA to be appended here e-switch assist:content:<CTA>
export const ESWITCH_PAGE_SCROLL_ONCLICKS = 'e-switch assist:content:scroll to:';
export const ESWITCH_PAGE_SCROLL_ONCLICKS_LEARN_MORE = 'e-switch assist:content:scroll to:comparison table';

// CTA to be appended here e-switch assist:try it for free:quick assessment:content:<CTA>
export const QUICK_ESTIMATE_TRY_IT_BUTTON_ONCLICKS = 'e-switch assist:try it for free:quick assessment:content:';

// CTA to be appended here e-switch assist:quick assessment:content:<CTA>
export const QUICK_ESTIMATE_TRY_IT_BELOW_LINK_ONCLICKS = 'e-switch assist:quick assessment:content:';

// CTA and Location to be appended here e-switch assist:content:<CTA>:<location>
export const GET_DETAILED_ASSESSMENT_BUTTON_ONCLICKS = 'e-switch assist:content:go to detailed assessment';

// CTA to be appended here e-switch assist:<CTA>:submit
export const GET_QUICK_ESTIMATE_SUBMIT_BUTTON_ONCLICKS = 'e-switch assist:content:quick estimate:show results';

// CTA to be appended here e-switch assist:content:tab:<CTA>
export const ESWITCH_PAGE_TAB_ONCLICKS = 'e-switch assist:content:tab:';

export const EMAIL_US_BUTTON_ONCLICKS = 'e-switch assist:content:click to email';

export const VEHICLE_DETAILS_BUTTON_ONCLICKS = 'referral:ford';

export const FORD_PRO_ACCOUNT_ONCLICKS = 'referral:ford:customer signup';

export const VEHICLE_DETAILS_BUTTON_REFERRED_TO = 'ford';

export const FORD_PRO_ACCOUNT_REFERRED_TO = 'ford:customer signup';

export const REFERRAL_EXIT_ONCLICK_LINK_NAME = 'exit:ford';

export const ONCLICK_LINK_NAME = 'fpro:e-switch assist:content action';

export const LOGIN_STATUS_TRUE = 'logged in';

export const LOGIN_STATUS_FALSE = 'logged out';

export const DETAILED_ASSESSMENT_PAGE_NAME = 'fpro:e-switch assist:detailed assessment:switch assessment';
export const VEHICLES_PAGE_NAME = 'fpro:e-switch assist:detailed assessment:vehicles';
export const DAILY_CHARGING_ASSESSMENT_PAGE_NAME = 'fpro:e-switch assist:detailed assessment:vehicles:profile:daily charging assessment';
export const YEARLY_CHARGING_PROJECTION_PAGE_NAME = 'fpro:e-switch assist:detailed assessment:vehicles:profile:yearly charging projection';
export const EXPORT_REPORT_BUTTON_ONCLICK_LINK_NAME = 'fpro:e-switch assist:detailed assessment:switch assessment:download';
export const EXPORT_REPORT_BUTTON_ONCLICK = 'e-switch assist:detailed assessment:switch assessment:download:Export Report';
